<template>
  <list-thumb-view getters='member' />
</template>

<script>
export default {
  components: { ListThumbView: () => { return import('./../users/ListThumbView') } }
}
</script>
